import { useCallback, useState } from 'react';

export function useShowMore() {
  const [shouldShowMore, setShouldShowMore] = useState(false);

  const toggleShowMore = useCallback(() => {
    setShouldShowMore((prev) => !prev);
  }, []);

  const resetShowMore = useCallback(() => {
    setShouldShowMore(false);
  }, []);

  return { shouldShowMore, toggleShowMore, resetShowMore };
}
